import { isEqual } from 'lodash';
import { configRRules } from 'utilities/configRRules';
import languages from 'languages/languages';

export function isEventChanged(values, initialValues, editMode, event, videos?, documents?, images?) {
  if (!editMode || !event || !initialValues) return false;

  const formChanged = !isEqual(values, initialValues);
  const currentAttachments = { images, documents, videos };

  const attachmentsChanged = Object.keys(currentAttachments).some(
    (key) => (event?.[key]?.length || 0) !== (currentAttachments[key]?.length || 0),
  );
  return formChanged || attachmentsChanged;
}

export function getEventPayload(values, images, documents, videos, withEndDate, enableParticipantsLimit, locale) {
  let { recurringConfig } = configRRules({
    rules: values.recurringRules,
    startDate: values.startDate,
    locale,
  });
  recurringConfig = recurringConfig.freq !== undefined && recurringConfig.freq !== 8 ? recurringConfig : undefined;
  let recurringText = {};
  if (recurringConfig) {
    const langs = languages();
    langs.forEach((lang) => {
      const { recurringLabel } = configRRules({
        rules: values.recurringRules,
        startDate: values.startDate,
        labels: lang.rrEventLabels,
        locale,
      });
      recurringText[lang.key2] = recurringLabel;
    });
  } else recurringText = undefined;
  const newParts = values.parts.map((part) => {
    const newQuestions = part.questions?.map((question) => {
      if (question.type === 'freeText') {
        delete question.options;
        return question;
      }
      const newOptions = question.options.filter((option) => !!option.title.length);
      return { ...question, options: newOptions };
    });
    return { ...part, questions: newQuestions };
  });
  return {
    ...values,
    registration: {
      type: values.registrationType,
      value: values.registrationLink,
    },
    images,
    documents,
    videos,
    endDate: values.endDate,
    hideEndDate: withEndDate,
    recurringConfig,
    invitedKreises: values.invitedKreises.map(({ _id }) => _id),
    sender: localStorage.getItem('userId'),
    recurringText,
    participantsLimit: enableParticipantsLimit ? values.participantsLimit : 0,
    parts: newParts,
  };
}
